function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19,25.68H29.63a.68.68,0,0,0,0-1.36H19l2.31-2.5a.69.69,0,0,0,.18-.5.64.64,0,0,0-.21-.46.68.68,0,0,0-.95,0l-3.36,3.64a.72.72,0,0,0-.19.47.6.6,0,0,0,.19.46l3.36,3.65a.68.68,0,0,0,.48.21h0a.66.66,0,0,0,.46-.19.71.71,0,0,0,0-.95Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.58,15.75H24.16a.7.7,0,0,0-.67.68v3a.65.65,0,0,0,.2.48.66.66,0,0,0,.94,0,.69.69,0,0,0,.2-.48V17.11h7.08V32.89H24.83V30.58a.69.69,0,0,0-.2-.48.66.66,0,0,0-.94,0,.65.65,0,0,0-.2.48v3a.69.69,0,0,0,.67.68h8.42a.69.69,0,0,0,.67-.68V16.43A.69.69,0,0,0,32.58,15.75Z"
});

var SvgIconLogOut = function SvgIconLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a132e0f4-0c41-40c7-a3b0-ad7cf590e6a1",
    "data-name": "Icons",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-log-out.850db0fa.svg";
export { ForwardRef as ReactComponent };